<template>
  <div class="logs">
    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span class="mdl-layout-title">logs</span>
        <div class="mdl-layout-spacer"></div>

      </div>
    </header>

    <div class="loading-holder" v-if="!logs">
      <h3>Loading Data...</h3>
      <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
      <h4>Please wait!</h4>
    </div>

    <div class="logs-card mdl-card mdl-shadow--2dp" v-if="logs" v-bind:class="{ blurred: state == 'working' }">
    <!--  <div class="mdl-card__supporting-text search">
        <i class="material-icons searchIcon">search</i>
        <div class="mdl-textfield mdl-js-textfield">
          <input class="mdl-textfield__input" type="text" id="search" v-model="search">
          <label class="mdl-textfield__label" for="search">Search...</label>
        </div>
      </div>-->
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="logs-list">
          <ul>
            <li v-for="log in logs">
              <router-link :to="{ name: 'log', params: { logId: log.logId } }">
                <span>{{ formatTime(log.date) }}</span>:
                <span>{{ log.ip }}</span>
              </router-link>
            </li>

          </ul>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

  import moment from 'moment'
  import api from "api"

  export default {
    name: 'logs',
    data () {
      return {
        state: 'loading',
        search: ''
      }
    },
    reactive: {
      logs: ['logs', 'logs']
    },
    computed: {
      sortedLogs() {
        return this.logs.sort
      }
    },
    watch: {
      logs() {
        this.state = 'loaded'
      }
    },
    methods: {
      formatTime(t) {
        return moment(t).format('MMMM Do YYYY, h:mm:ss a')
      },
      addUser() {
        this.state = 'working'
        api.request(['userAdmin', 'createUser'], 'empty').then(
          userId => {
            this.$router.push({ name:'user', params: { userId } })
          }
        )
      },
      openAddEmailPasswordDialog() {
        this.newEmail = ''
        this.newPassword = ''
        this.addEmailPasswordDialog = true
      },
      addEmailPassword() {
        this.addEmailPasswordDialog = false
        this.state = 'working'
        api.request(['userAdmin', 'createEmailUser'], this.newEmail, this.newPassword).then(
          userId => {
            this.state = 'loaded'
            this.$router.push({ name:'user', params: { userId } })
          }
        )
      }
    },
    created() {
    },
    beforeDestroy() {
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .logs-card {
    margin: 23px auto auto;
    min-height: 70vh;
    min-width: 91%;
  }

  .logs-list > div {
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .logs-list a {
    color: rgb(28, 105, 140);
    text-decoration: none;
  }
  .logs-list a:hover {
    color: rgb(37, 149, 201);
    text-decoration: underline;
  }
  .logs-list .user-icon {
    margin-right: 12px;
    vertical-align: middle;
  }
  .logs-list .user-name {
  }

  .loading-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }
  .loading-holder .mdl-progress {
    margin-left: auto;
    margin-right: auto;
  }


  .search {
    padding-top: 0;
    padding-bottom: 0;
  }
  .searchIcon {
    position: relative;
    top: 7px;
  }
  .search .mdl-textfield {
    width: calc(100% - 90px);
  }

  td {
    padding: 1em;
  }
  tr {
    cursor: pointer;
  }
  tr:hover {
    background: lightcyan;
  }

</style>



// WEBPACK FOOTER //
// Logs.vue?8858040e